import { render } from "./BackendCategoryTree.vue?vue&type=template&id=076af91d"
import script from "./BackendCategoryTree.vue?vue&type=script&lang=js"
export * from "./BackendCategoryTree.vue?vue&type=script&lang=js"

import "./BackendCategoryTree.vue?vue&type=style&index=0&id=076af91d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__